import clsx from "clsx";

import { valueAsString } from "@tsmono/util";

import { ScoreValue } from "../../../../@types/extraInspect";
import { ScoreDescriptor, SelectedScore } from "../types";

import styles from "./BooleanScoreDescriptor.module.css";

export const booleanScoreDescriptor = (): ScoreDescriptor => {
  return {
    scoreType: "boolean",
    compare: (a: SelectedScore, b: SelectedScore) => {
      return Number(a.value) - Number(b.value);
    },
    render: (score: ScoreValue) => {
      return (
        <span
          className={clsx(
            styles.circle,
            "text-size-smallest",
            score ? styles.green : styles.red
          )}
        >
          {valueAsString(score)}
        </span>
      );
    },
  };
};
